import React, { useState, useEffect } from 'react';
import styles from './index.module.sass';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const PlateNumberPredict = ({ value, onPlateNumberChange }) => {
  const [currentValue, setCurrentValue] = useState(value);
  const [isShow, setIsShow] = useState(false);
  const [currentPlates, setCurrentPlates] = useState([]);

  useEffect(() => {
    if (value.length < 2 || value.length > 7 || value.includes('-')) {
      return setIsShow(false);
    }
    setIsShow(true);
    setCurrentValue(value);
  }, [value]);

  useEffect(() => {
    const valueSlice = pos => {
      let firstValue = value.slice(0, pos);
      let lastValue = value.slice(pos, value.length);
      return firstValue.concat('-', lastValue);
    };

    setCurrentPlates(() => {
      switch (currentValue.length) {
        case 2:
          return [valueSlice(2)];
        case 3:
          return [valueSlice(2), valueSlice(3)];
        case 4:
        case 5:
        case 6:
          return [valueSlice(2), valueSlice(3), valueSlice(4)];
        case 7:
          return [valueSlice(3)];
        default:
          return [];
      }
    });
  }, [value, currentValue]);

  return (
    <div className={cx({ 'predict-button-group': true, show: isShow })}>
      {currentPlates.map((text, key) => (
        <div key={key} onClick={() => onPlateNumberChange(text)}>
          {text}
        </div>
      ))}
    </div>
  );
};

export default PlateNumberPredict;
